import React, { useEffect, useState } from "react";
import TopMonthlyUsers from "./TopMonthlyUsers";
import useAnalytics from "./AnalyticsHook";
import WidgetPageWrapper from "./WidgetPageWrapper";
import { Spinner } from "react-bootstrap";

const TopMonthlyUsersPage = () => {
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const { FetchAnalyticsData } = useAnalytics();

  const [analyticsSessionHistories, setAnalyticsSessionHistories] = useState(
    []
  );
  const [analyticsCurrentMonthCode, setAnalyticsCurrentMonthCode] = useState(
    []
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (cancelled) return;
      try {
        setAnalyticsLoading(true);

        var responseData = await FetchAnalyticsData();
        if (cancelled) return;

        setAnalyticsCurrentMonthCode(responseData.currentMonthCode);
        setAnalyticsSessionHistories(responseData.sessionHistories);
        // setAnalyticsActiveUsers(responseData.activeUsers);
      } catch (error) {
        console.log(error);
      } finally {
        setAnalyticsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <WidgetPageWrapper title={"Top Monthly Users"} loading={loading}>
        {analyticsLoading ? (
          <Spinner />
        ) : (
          <TopMonthlyUsers
            currentMonthCode={analyticsCurrentMonthCode}
            monthlyHistories={analyticsSessionHistories}
            mode={"page"}
            setLoading={setLoading}
          />
        )}
      </WidgetPageWrapper>
    </>
  );
};

export default TopMonthlyUsersPage;
